module.exports = __webpack_public_path__ + "img/authTwo.e11c7074.png";